import { useTranslation } from "react-i18next";

export default function TrustBar() {
  const { t } = useTranslation();

  const items = [
    { icon: "ri-check-double-line", text: t("trust.verified") },
    { icon: "ri-image-line", text: t("trust.qc") },
    { icon: "ri-book-open-line", text: t("trust.guides") },
    { icon: "ri-shield-check-line", text: t("trust.safe") },
    { icon: "ri-refresh-line", text: t("trust.daily") },
  ];

  return (
    <section className="bg-background-100">
      <div className="px-4 md:px-6 py-5">
        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8">
          {items.map((item) => (
            <div
              key={item.text}
              className="flex items-center gap-2 text-foreground-600 text-xs md:text-sm whitespace-nowrap"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className={`${item.icon} text-accent-500 text-sm`}></i>
              </span>
              {item.text}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}